<script>
import Header from './Header.vue';
import ScrollToTop from './ScrollToTop.vue';

export default {
  components: {
    'header-component': Header,
    ScrollToTop
  },
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  },
  mounted() {
      window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
      handleScroll: function () {
        if (this.scTimer) return;
        this.scTimer = setTimeout(() => {
          this.scY = window.scrollY;
          clearTimeout(this.scTimer);
          this.scTimer = 0;
        }, 100);
      },
      toTop: function () {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      },
    },
}
</script>
<template>
  <div role="main">
    <div class="top-wrap">
      <div class="top-content">
        <div class="top-banner">
          <header-component></header-component>
          <h1>Population Identification Processes</h1>
          <h2>Identifying adults with schizophrenia who may benefit most from treatment with a long-acting injectable antipsychotic (LAI)</h2>

          <section>
            <p>
              Patient identification enables organizations to identify the right services and level of care for adults with schizophrenia who might be appropriate for treatment with LAIs. A “one-size-fits-all” model, where the same level of resources is offered to every patient, is clinically ineffective and costly.<sup>1</sup>
            </p>
            <p>
              The Healthcare Cost and Utilization Project (HCUP)  researchers reported that schizophrenia is among the top 10 principal diagnoses of super-utilizers (defined as Medicare or Medicaid patients with 4 or more all-cause hospitalizations or privately insured patients with 3 or more all-cause hospitalizations within a  1-year time period) in 2012.<sup>2</sup>
            </p>
          </section>

        </div>
      </div>

      <div class="bottom-banner">
        <p>Approaches to Appropriate Patient Identification</p>
        <p class="bottom-banner-text">
        Stratifying the patients according to healthcare needs may allow healthcare organizations to target adults with schizophrenia who might be appropriate for treatment with LAIs. Some approaches are very complex, but basic approaches can also be effective, particularly for organizations just starting LAI treatment programs.
        </p>
      </div>
    </div>

    <div class="list-content">
      <div class="list-wrap">
        <div class="list-item">
          <div class="pdf-icon">Population Identification Methods</div>
          <p>Learn about population identification methods you can use with your own data to understand distinct subgroups (eg, nonadherent patients, high utilizers) that might be appropriate for treatment with LAI therapy.</p>
           <a href="/static/files/cp-179676v2_Appropriate_Population_Identification_Methods.pdf" aria-label="Download Population Identification Methods PDF" target="_blank" class="button download">DOWNLOAD <img src="../img/down-icon.png" alt=""/></a>
        </div>
        <div class="list-item">
          <div class="xls-icon">Population Identification Worksheet</div>
          <p>Worksheet to help you identify appropriate patients within your population for treatment with LAI therapy.</p>
          <a href="/static/files/cp-179677v2_Appropriate_Population_Identification_Worksheet.xlsx" aria-label="Download Population Identification Worksheet" target="_blank" class="button download">DOWNLOAD <img src="../img/down-icon.png" alt=""/></a>
        </div>
      </div>
      <ScrollToTop />
    </div>

    <div class="home-body footer-references">
      <p>
        <strong>References: 1.</strong> Academy of Managed Care Pharmacy. Disease Management. Published July 17, 2019. Accessed November 20, 2023. <span><a style="display: inline; color: #363636;word-break: break-all;" href="https://www.amcp.org/about/managed-care-pharmacy-101/concepts-managed-care-pharmacy/disease-management">https://www.amcp.org/about/
        managed-care-pharmacy-101/concepts-managed-care-pharmacy/disease-management</a></span> <strong>2.</strong> Jiang HJ, Weiss AJ, Barrett ML, Sheng M. Characteristics of hospital
         stays for super-utilizers by payer, 2012: Statistical Brief #190. In: <i>Healthcare Cost and Utilization Project (HCUP) Statistical Briefs.</i> Agency for Healthcare Research
          and Quality (US). May 2015. Accessed November 20, 2023. <span><a style="display: inline;color: #363636;word-break: break-all;" href="https://www.hcup-us.ahrq.gov/reports/statbriefs/sb190-Hospital-Stays-Super-Utilizers-Payer-2012.pdf">https://www.hcup-us.ahrq.gov/reports/statbriefs/sb190-Hospital-Stays-Super-Utilizers-Payer-2012.pdf</a></span>
      </p>
    </div>
  </div>

</template>

<style scoped>
#app > div {
  width: 100%;
  }

/*TOP */

  .top-wrap{
    background: rgb(0,18,82);
    background: linear-gradient(0deg, rgba(0,18,82,1) 0%, rgba(0,70,126,1) 50%, rgba(0,70,126,1) 100%);
    color: #ffffff;
    /*height: 906px;*/
    padding-bottom: 65px;
    width: 100%;
  }
  .top-content{
    background: linear-gradient(to top, #0079A8, #0084B8);
    border-radius: 0 0 0 100px;
    /*height: 653px;*/
    margin-left: 3%;
    width: 97%;
  }
  .top-banner{
    background: url(../img/banner-bg.png) no-repeat 0 0;
    background-size: cover;
    border-radius: 0 0 0 100px;
    /*height: 597px;*/
    margin-left: 1.5%;
    margin-bottom: 56px;
    padding-bottom: 85px;
    width: 98.5%;
  }

.top-banner h1{
  display: block;
  font-family: "Gotham", sans-serif;
  font-size: 36px;
  font-weight: bold;
  line-height: 1.2;
  margin: 68px auto 28px auto;
  max-width:1121px;
  text-align: center;
}

.top-banner h2{
  display: block;
  font-family: GothamBook, sans-serif;
  font-size: 22px;
  font-style: italic;
  font-weight: 400;
  line-height: 24px;
  margin: 0 auto;
  max-width:1121px;
  text-align: center;
  width: 100%;
}

.top-banner section{
  font-family: "GothamBook", sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  margin: 40px auto 0 auto;
  text-align: center;
  max-width:1121px;
}

.top-banner section p{
    margin: 1em auto;
}

.top-content p.banner-footer{
  font-family: "GothamBook", sans-serif;
  font-size: 24px;
  text-align: center;
}

.bottom-banner{
  color: #FFFFFF;
  display: block;
  font-family: GothamMedium, sans-serif;
  font-size: 20px;
  font-weight: 700;
  margin: 70px auto 0 auto;
  text-align: left;
  width: 1120px;
}

.bottom-banner-text{
  color: #ffffff;
  font-family: GothamBook, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
}

.bottom-banner-text sup{
  font-size: 11px;
  font-weight: 400;
  position: relative;
  top: -0.2em;
  vertical-align: top;
}

.list-content{
  background: #eeeef3;
  margin: 0 auto;
  position: relative;
  width: 100%;
}

.list-wrap{
  background: #eeeef3;
  display: block;
  margin: 65px auto;
  width: 1121px;
}

.list-item{
  background-color: #ffffff;
  border-radius: 0 35px 0 35px;
  box-shadow: 10px -5px 30px 0px rgba(0,0,0,0.15);
  -moz-box-shadow: 10px -5px 30px 0px rgba(0,0,0,0.15);
  -webkit-box-shadow: 10px -5px 30px 0px rgba(0,0,0,0.15);
  height: 400px;
  margin-right: 38px;
  position: relative;
  vertical-align: top;
  width: 349px;
}

.list-item a{
  color: #000000;
  display: block;
  font-family: Gotham, sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  margin: 30px;
  padding-right: 45%;
}

.list-item p{
  color: #000000;
  font-family: GothamBook, sans-serif;
  font-size: 14px;
  font-weight: 400;
  margin: 0 30px;
  line-height: 17px;
}

.list-item .button{
  background: rgb(26,64,132);
  background: linear-gradient(90deg, rgba(26,64,132,1) 0%, rgba(84,51,143,1) 80%, rgba(84,51,143,1) 100%);
  border-radius: 0 0 0 35px;
  border: 0px;
  height: 70px;
  border-top: 4px solid #1c75bc;
  bottom: 0px;
  color: #ffffff;
  font-family: "GothamBook", sans-serif;
  font-size: 18px;
  font-weight: bold;
  line-height: 60px;
  margin: 0;
  padding: 0 70px 0 0;
  position: absolute;
  text-align: right;
  text-decoration: none;
  width: calc( 100% - 70px);
}

.list-item .button img{
  position: absolute;
  top: 14px;
  right: 15px;
}

.list-item .button.visit{
  background: rgb(21,129,198);
  background: linear-gradient(90deg, rgba(21,129,198,1) 0%, rgba(2,164,226,1) 100%);
  border-top-color: #00467e;
}

.pdf-icon,
.xls-icon {
  color: #000000;
  display: block;
  font-family: Gotham, sans-serif;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  margin: 30px;
  padding-right: 45%;
}

.pdf-icon{
  background: url(../img/pdf-icon.png) no-repeat top right;
}
.xls-icon{
  background: url(../img/xls-icon.png) no-repeat top right;
}




.home-body{
  display: block;
  font-family: "GothamBook", sans-serif;
  color:#000000;
  font-size: 14px;
  line-height: 20px;
  margin: 59px auto 0 auto;
  width: 1121px;
  word-break: break-word;
}

.footer-references span{
  word-break: break-all;
}

.resources{
  display: block;
  margin: 80px auto;
  width: 1187px;
}

.resources > div{
  padding-left: 16px;
  vertical-align: top;
  width: 277px;
}

.resources > div:first-child{
  padding-left: 0px;
}

.resources > div:last-child .resource_info_wrap{
  border: 0;
}

.resources .resource_info_wrap{
  border-right: 1px solid #667f9d;
  margin: 0 15px 25px 0;
  padding-right: 16px;
  text-align: center;
  width: calc(100% - 16px);
}

.resources > div h3{
  color: #1c75bc;
  height: 60px;
  margin: 25px auto 0 auto;
  width: 140px;
}

.top-link{
  background: url(../img/icon-backToTop.png) no-repeat center right;
  bottom: 65px;
  color: #A65103;
  font-family: GothamMedium, sans-serif;
  font-size: 18px;
  position: absolute;
  right: 115px;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  line-height: 42px;
  padding-right: 56px;
}



.site-guide, #menuToggle, #boton, .home{
  display: none;
}

strong{
  font-weight: bold;
}

@media screen and (max-width: 1230px){
  footer img{
    left: 78%;
  }

  .top-banner *, .body * {
    max-width: 95%;
  }

  .top-banner h2, .top-banner section{
    max-width: 95%;
  }

  .bottom-banner, .list-wrap, .home-body{
    width: 90%;
  }

  .list-wrap{
    margin-bottom: 40px;
    text-align: center;
  }

  .list-item{
    margin: 0 38px 60px 0;
    text-align: left;
  }

  .top-link{
    bottom: 35px;
  }

}

@media screen and (max-width: 880px){

   .top-banner{
    background: url(../img/banner-mobile2-bg.png) no-repeat 0 0;
    background-size: cover;
    border-radius: 0 0 0 100px;
    margin-left: 1.5%;
    padding-bottom: 46px;
    width: 98.5%;
  }

  .top-banner section{
    font-family: GothamBook, sans-serif;
    font-size: 20px;
    line-height: 30px;
    width: 86%;
  }

  .top-content p.banner-footer{
    font-size: 30px;
    margin: 24px auto;
    width: 73%;
  }

  .resources{
    margin: 80px auto 0 auto;
    width: 80%;
  }

  .resources > div{
    padding-left: 0;
    margin-right: 28px;
    margin-bottom: 70px;
    width: 297px;
  }

  .resources div:nth-child(2n){
    margin-right: 0;
    width: 260px;
  }

  .resources div:nth-child(2n) .resource_info_wrap{
    border-right: 0;
    margin: 0 0 25px 0;
  }

  .resources .resource_info_wrap{
    margin: 0 37px 25px 0;
    padding-right: 0px;
    width: 100%;
  }

  .home-body{
    width: 87%;
  }

  .site-guide, #menuToggle, #boton, .home{
    display: block;
  }

  .home a{
    background: url(../img/icon-menu-home.png) no-repeat left center;
  }
  .population-identification{
    background: url(../img/icon-menu-glass.png) no-repeat left center;
  }
  .expanding-capabilities{
    background: url(../img/icon-menu-expanding.png) no-repeat left center;
  }
  .collaborative-care{
    background: url(../img/icon-menu-hands.png) no-repeat left center;
  }
  .process-evaluation{
    background: url(../img/icon-menu-process.png) no-repeat left center;
  }
  .resource-library{
    background: url(../img/icon-menu-resources.png) no-repeat left center;
  }
  .site-guide{
    background: url(../img/icon-menu-book.png) no-repeat left center;
  }

  .top-banner h2{
    width: 96%;
  }

  .bottom-banner{
    padding-left: 60px;
    padding-right: 60px;
    width: calc(100% - 120px);
  }

  .step-item-desc-wrap{
    width: 95%;
  }

  .step-item{
    text-align: center;
  }

  .step-circle{
    margin: 60px 0 45px 0;
  }

  .step-item-desc-wrap{
    text-align: left;
  }

  .list-wrap{
    width: 100%;
  }

  .list-content{
    padding-bottom: 50px;
  }

  .list-item{
    margin: 0 20px 60px 0;
    width: 300px;
  }

  .list-item button{
    width: 300px;
    background-size: contain;
  }

  .body{
    width: 90%;
  }

  .body-list-wrap, .body .references, .body-list-item button{
    width: 100%;
    word-wrap: break-word;
  }

  .body-list-item {
    margin-right: 37px;
    width: 300px;
  }

  .body-list-item:nth-child(2n) {
    margin: 0;
  }

  .body-list-item:nth-child(3n) {
      margin: 0 32px 78px 0;
  }

  .top-link{
    background: url(../img/icon-backToTop.png) no-repeat center right;
    bottom: 30px;
    color: #A65103;
    font-family: GothamMedium, sans-serif;
    font-size: 18px;
    position: absolute;
    right: 35px;
    display: inline-flex;
    cursor: pointer;
    align-items: center;
    line-height: 42px;
    padding-right: 56px;
  }
}

@media screen and (max-width: 540px){

  .top-banner h1{
    font-size: 19px;
    line-height: 23px;
    max-width: 85%;
    margin: 40px auto 0 auto;
  }

  .top-banner h2{
    display: block;
    font-size: 19px;
    line-height: 23px;
  }


  .top-banner section{
    font-size: 13px;
    line-height: 16px;
  }

  .top-content p.banner-footer{
    font-size: 15px;
    line-height: 18px;
  }

}

@media screen and (max-width: 415px){

  .resources .resource_info_wrap{
    border-right: 0;
    margin: 0 0 25px 0;
  }

  .resources div a{
    display: block;
    height: 55px;
  }

  .resources > div button{
    width: 100%;
  }

  .resources > div, .resources div:nth-child(2n){
    width: 100%;
  }

  .bottom-banner{
    font-size: 15px;
    line-height: 18px;
    margin-top: 34px;
    padding: 0;
    width: 84%;
  }

  .bottom-banner-text{
    font-size: 14px;
    line-height: 17px;
  }

  .list-item{
    margin: 0 0 60px 0;
  }

  .top-banner section{
    font-size: 23px;
  }

  .body{
    width: 82%;
  }

  .body-list-item, .body-list-item:nth-child(2n), .body-list-item:nth-child(3n){
    margin: 0 32px 78px 20px;
  }

  .top-banner h1{
    font-size: 19px;
    line-height: 23px;
    max-width: 85%;
    margin: 40px auto 21px auto;
  }

  .top-banner h1 span{
    display: block;
    font-size: 19px;
    line-height: 23px;
  }

  .top-banner section{
    font-size: 13px;
    line-height: 16px;
  }

  .top-content p.banner-footer{
    font-size: 15px;
    line-height: 18px;
  }

   @supports (-webkit-touch-callout: none) {
    .filter-list span{
      line-height: 32px;
    }

    .filter-content .apply{
      line-height: 70px;
    }

    .top-link{
      padding-top: 12px;
    }

  }

}


/* new styles sergio */

@media screen and (max-width: 880px){

    .home a{
        background-size: 38px auto;
    }
    .population-identification{
        background-size: 37px auto;
    }
    .expanding-capabilities, .collaborative-care{
        background-size: 35px auto;
    }

    .process-evaluation, .resource-library{
      background-size: 31px auto;
    }

    .site-guide{
      background-size: 33px auto;
    }

    .top-banner header .logo img{
      width: 60%;
    }

}

@media screen and (max-width: 415px){

  .top-banner{
    padding-bottom: 6px;
  }

  .top-banner h1{
    font-size: 19px;
    line-height: 23px;
    width: 82%;
  }

  .top-banner h2{
    font-size: 16px;
    line-height: 18px;
    width: 82%;
  }

  .top-banner h1 span{
    display: block;
    font-size: 14px;
    line-height: 18px;
    margin-top: 20px;
  }

  .top-banner section{
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    margin-top: 25px;
    width: 82%;
  }

  .top-content p.banner-footer{
    font-size: 15px;
    line-height: 18px;
  }

}

/*Tag Sup*/
.bottom-banner sup{
      font-size: 11px;
      font-weight: 400;
      margin: 0 0 0 2px;
      vertical-align: text-bottom;
}

.top-banner sup{
      font-size: 11px;
      font-weight: 400;
      margin: 0 0 0 2px;
      vertical-align: 6px;
      line-height: 1;
}

@media screen and (max-width: 880px){
  .top-banner sup{
    vertical-align: 8px;
    line-height: 1;
  }
}

@media screen and (max-width: 540px){
  .top-banner sup, .bottom-banner sup{
    font-size: 8px;
    line-height: 1;
    vertical-align: 4px;
  }
}
/*.TagSup*/

</style>





// WEBPACK FOOTER //
// src/components/Population_Identification_Processes.vue